import clsx from 'clsx'
import type {CSSProperties} from 'react'
import {Link} from 'react-router-dom'

interface Props {
    url: string
    height?: number
    label?: string | null
    className?: string
    labelClassName?: string
    alt?: string
    // Короткий вариант картинки в виде одной буквы.
    // При short === true, label = false всегда.
    short?: boolean
    fullLogoUrl?: string
    fullLogoWrapperStyle?: CSSProperties
    fullLogoStyle?: CSSProperties
    logoLabelStyle?: CSSProperties
}

// Логотип приложения с подписью для шапки и подвала сайта.
export function LogoWithLabel(props: Props) {

    const {
        url,
        height,
        label,
        className,
        labelClassName,
        alt,
        short,
        fullLogoUrl,
        fullLogoWrapperStyle,
        fullLogoStyle,
        logoLabelStyle,
    } = props

    const img = (
        <img
            src={short ? '/img/dotoku-short.svg' : (fullLogoUrl ?? '/img/dotoku.svg?v=20260930')}
            alt={alt}
            height={height}
            style={fullLogoUrl ? fullLogoStyle : undefined}
        />
    )

    const imgWithWrapper = fullLogoUrl ? (
        <span
            style={fullLogoWrapperStyle}
            className="d-block overflow-visible"
        >
            {img}
        </span>
    ) : img

    return (
        <Link
            to={url}
            className={clsx(
                'logo-with-label',
                short ? 'logo-with-label-short' : '',
                className
            )}
        >
            {imgWithWrapper}
            {label && !short && (
                <span
                    className={clsx('d-block logo-label', labelClassName)}
                    style={logoLabelStyle}
                >
                    {label}
                </span>
            )}
        </Link>
    )
}
